import { withTranslation } from "react-i18next";

import React from 'react';
import { Link } from 'react-router-dom';
import { SideBar } from '../Common/SideBar';
import { DashboardHeader } from '../Common/DashboardHeader';
import { Footer, Header } from '../Common';
import Products from '../../Models/Products';
import Menu, { SubMenu, Item as MenuItem } from 'rc-menu';
import ProductsUpload from '../../Models/ProductsUpload';
import Pagination from "react-js-pagination";
import "bootstrap/scss/bootstrap.scss";
import Common from "../../Models/Common";
// import { connect } from 'react-redux';
// import { buyerLogin } from '../../../Action/login';

class SearchResult extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            minHeight: "475px",
            sellersList: [],
            productsList: [],
            activePage: 1,
            itemsCountPerPage: 10,
            pageRangeDisplayed: 5,
            categories: [],
            allCategories: [],
            categoryProducts: [],
            allProducts: [],
            total: []
        };
        this.getTotal();
        this.getAllCategories();
        this.getCategory();
        // this.getAllProducts();
    }
    componentDidMount() {
        window.scrollTo(0, 0)
        Products.getSearchResult(this.props.location.state.id, 1).then(res => {
            console.log(res.data.total)
            if (res.data != null) {
                this.setState({ productsList: res.data.products })
                this.setState({ total: res.data.total, pageRangeDisplayed: this.state.pageRangeDisplayed, itemsCountPerPage: this.state.itemsCountPerPage })
            }
        })
    }

    getCategory() {
        ProductsUpload.getCategory().then(res => {
            this.setState({ categories: res.data.categories })
        })
    }
    handleClick(id) {
        this.props.history.push(`/sub-categories/${id}`);
    }
    getAllProducts() {
        Products.getProductsList(this.props.location.state.id, 1).then(res => {
            this.setState({ allProducts: res.data.payload, total: res.data.total, pageRangeDisplayed: this.state.pageRangeDisplayed, itemsCountPerPage: this.state.itemsCountPerPage })
        })
    }

    getAllCategories() {
        Products.getProductsList(this.props.location.state.id, 1).then(res => {
            this.setState({ allCategories: res.data.cat_name })
        })
    }
    getTotal() {
        Products.getProductsList(this.props.location.state.id, 1).then(res => {
            this.setState({ total: res.data })
        })
    }

    handlePageChange(pageNumber) {
        console.log(pageNumber)
        Products.getSearchResult(this.props.location.state.id, pageNumber).then(res => {
            console.log(res.data)
            this.setState({ productsList: res.data.products ,activePage: pageNumber, total: res.data.total, pageRangeDisplayed: this.state.pageRangeDisplayed, itemsCountPerPage: this.state.itemsCountPerPage })
        })
    }
    pagination() {
        if (this.state.total < 10) {
            return (
                <div></div>
            )
        } else {
            console.log(this.state.total)
            return (
                <div className="row">
                    <div className="col-md-6"></div>
                    <div className="col-md-6 ">
                        <Pagination
                            hideNavigation
                            activePage={this.state.activePage}
                            itemsCountPerPage={this.state.itemsCountPerPage}
                            totalItemsCount={this.state.total}
                            pageRangeDisplayed={this.state.pageRangeDisplayed}
                            onChange={this.handlePageChange.bind(this)}
                        />
                        {/* <Pagination
                            hideNavigation
                            activePage={this.state.activePage}
                            itemsCountPerPage={10}
                            totalItemsCount={10}
                            pageRangeDisplayed={5}
                            onChange={this.handlePageChange.bind(this)}
                        /> */}
                    </div>
                    <div className="col-md-0"></div>
                </div>
            )
        }
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-md-3 remember_text">
                                        </div>
                                        <div className="col-md-9 large_fonts">
                                            <div className=" mb-3 input_name  " style={{ width: '100%', textAlign: 'left', fontSize: '20px' }}>
                                                {this.props.t('0')}
                                            </div>
                                            <div className="col-md-12" style={{ border: "1px solid #ddd", minHeight: "400px", padding: "4%" }}>
                                                {this.state.productsList.map(group =>
                                                    <div className="" key={group.id} >
                                                        <div className="service-list-divs" style={{ border: '1px solid #f4f2f0' }}>
                                                            <div className="col-md-12">
                                                                <div className="row">
                                                                    <div className="col-md-3">
                                                                        {/* <div><img alt="" src={require("../../assets/images/image1.jpeg")} height="auto" width='100%' /></div> */}
                                                                        <div><img alt="" src={Common.baseUrl + group.img} height="100" width="100%" style={{ objectFit: 'cover' }} /></div>
                                                                    </div>
                                                                    <div className="col-md-9">
                                                                        <div style={{ textAlign: "left", paddingTop: "2%", fontSize: "18px", borderBottom: "1px solid #bababa" }}>{group.title}</div>
                                                                        <div style={{ textAlign: "left", paddingTop: "2%", fontSize: "12px", height: "80px" }}>{group.short_desc}...</div>
                                                                        <div style={{ textAlign: "right" }}><Link to={{
                                                                            pathname: `/categories-details/${group.id}`,
                                                                            state: { id: group.id }
                                                                        }} className="sky-a" >
                                                                            {this.props.t('1')}</Link></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <br />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-0"></div>
                                <div className="mt-2 col-6 ml-4">
                                    {this.pagination()}
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            );
        }
        //for desktop view
        else if (isDesktop) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="row">
                                        {/* <div className="col-md-3 remember_text">
                                            <div style={{ fontSize: '12px' }}>
                                                <Menu style={{ border: '0px solid #d9d9d9', cursor: 'pointer' }}>
                                                    {this.state.categories.map(data => {
                                                        // console.log(data)
                                                        if (data.sub_category.length === 0)
                                                            return (
                                                                <MenuItem key={data.id}>
                                                                    <Link to={{
                                                                        pathname: '/sub-categories',
                                                                        state: { id: data.id }
                                                                    }} className="category-right" style={{ fontSize: '12px' }}>{data.category}</Link>
                                                                </MenuItem>
                                                            )

                                                        return (
                                                            <SubMenu title={data.category} key={data.category} style={{ paddingTop: "5px", paddingBottom: "5px", cursor: 'pointer' }}>
                                                                {data.sub_category.map((subcat) => {
                                                                    return <MenuItem key={subcat.id} style={{ cursor: 'pointer' }}>
                                                                        <div to={{
                                                                            pathname: '/sub-categories',
                                                                            state: { id: subcat.id }
                                                                        }} onClick={this.handleClick.bind(this, subcat.id)} className="category-right">{subcat.cat_name}</div></MenuItem>
                                                                })}
                                                            </SubMenu>
                                                        )
                                                    })}
                                                </Menu>
                                            </div>
                                            <div>&nbsp;</div>
                                        </div> */}
                                        <div className="col-md-12 large_fonts">
                                            <div className=" mb-3 input_name big_font " style={{ width: '100%', textAlign: 'left' }}>
                                                {this.props.t('0')}
                                            </div>
                                            <div className="col-md-12" style={{ border: "1px solid #ddd", minHeight: "400px", padding: "2%" }}>
                                                {this.state.productsList.map(group =>
                                                    <div className="" key={group.id} >
                                                        <div className="service-list-divs" style={{ border: '1px solid #f4f2f0' }}>
                                                            <div className="col-md-12">
                                                                <div className="row">
                                                                    <div className="col-md-3">
                                                                        {/* <div><img alt="" src={require("../../assets/images/image1.jpeg")} height="auto" width='100%' /></div> */}
                                                                        <div style={{ marginTop: '15px' }}><img alt="" src={Common.baseUrl + group.img} height="100" width="100%" style={{ objectFit: 'cover' }} /></div>
                                                                    </div>
                                                                    <div className="col-md-9">
                                                                        <div style={{ textAlign: "left", paddingTop: "2%", fontSize: "18px", borderBottom: "1px solid #bababa" }}>{group.title}</div>
                                                                        <div style={{ textAlign: "left", paddingTop: "2%", fontSize: "12px", height: "80px" }}>{group.short_desc}...</div>
                                                                        <div style={{ textAlign: "right" }}><Link to={{
                                                                            pathname: `/categories-details/${group.id}`,
                                                                            state: { id: group.id }
                                                                        }} className="sky-a" >
                                                                            {this.props.t('1')}</Link></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <br />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-0"></div>
                                <div className="mt-2 col-md-12">
                                    {this.pagination()}
                                </div>
                                {/* <div className="col-md-4 input_name">
                                </div>
                                <div className="col-md-8">
                                    <div className="mt-5 mb-3 input_name big_font guide_text">
                                        Products
                                    </div>
                                    <div className="col-md-12" style={{ border: "1px solid #ddd", minHeight: "400px", padding: "4%" }}>
                                        {this.state.productsList.map(group =>
                                            <div className="service-list-divs">
                                                <div className="col-md-12">
                                                    <div className="row">
                                                        <div className="col-md-3">
                                                            <div><img alt="" src={group.img} height="auto" width="100%" /></div>
                                                        </div>
                                                        <div className="col-md-9">
                                                            <div style={{ textAlign: "left", paddingTop: "2%", fontSize: "18px", borderBottom: "1px solid #bababa" }}>{group.title}</div>
                                                            <div style={{ textAlign: "left", paddingTop: "2%", fontSize: "12px", height: "100px" }}>{group.short_desc}...</div>
                                                            <div style={{ textAlign: "right" }}><Link to={{
                                                                pathname: `/categories-details/${group.id}`,
                                                                state: { id: group.id }
                                                            }} className="sky-a" >Details</Link></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div> */}


                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            );
        }
    }
}

export { SearchResult };


 SearchResult = withTranslation('src_Components_Search_SearchResult')(SearchResult);